import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "@/components/ui/sonner";
import LandingPage from "@/pages/LandingPage";
import CaseStudyPage from "@/pages/CaseStudyPage";
import BusinessCardPage from "@/pages/BusinessCardPage";
import BusinessCardExport from "@/pages/BusinessCardExport";
import FreeReviewPage from "@/pages/FreeReviewPage";
import FreeReviewSuccessPage from "@/pages/FreeReviewSuccessPage";

function App() {
  return (
    <HelmetProvider>
      <div className="App">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/case-study/repair-cafe" element={<CaseStudyPage />} />
            <Route path="/brand/business-card" element={<BusinessCardPage />} />
            <Route path="/brand/business-card/export" element={<BusinessCardExport />} />
            <Route path="/free-review" element={<FreeReviewPage />} />
            <Route path="/free-review-success" element={<FreeReviewSuccessPage />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </div>
    </HelmetProvider>
  );
}

export default App;
